import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PagedCompetencies from './components/PagedCompetencies/PagedCompetencies';
import CompetencyIcon from './components/CompetencyIcon/CompetencyIcon';
import CompetencyScoreBar from './components/CompetencyScoreBar/CompetencyScoreBar';
import ReportHelper from '../../helpers/ReportHelper';
import style from './style/competencyprofileextended.scss';

class CompetencyProfileExtended extends Component {

    getCompetenciesWithTags(competencies, languageId, i18n) {
        const tags = {};
        const competenciesWithoutTag = [];

        competencies.forEach(competency => {
            let tag = competency.competencyAliases[languageId]?.tag;
            if (tag) {
                if (!tags[tag]) {
                    tags[tag] = [];
                }
                tags[tag].push(competency);
            } else {
                competenciesWithoutTag.push(competency);
            }
        });

        return [
            ...Object.entries(tags).map(([tag, competencies]) => ({
                tag,
                competencies
            })),
            {
                tag: i18n.report_competency_tag_no_tag,
                competencies: competenciesWithoutTag
            }
        ];
    }

    getRenderedCompetency(
        competencies,
        openCompetencyExtendedModal,
        closeCompetencyExtendedModal,
        classes,
        i18n,
        languageId,
        competency,
        index
    ) {
        // this is passed on to the implementing component, to populate the modal
        const modalContent = <section>
            <PagedCompetencies
                competencies={ competencies }
                active={ competency.handle }
                closeCompetencyExtendedModal={ closeCompetencyExtendedModal }
                i18n={ i18n }
                languageId={languageId}
            />
        </section>;

        return <li
            key={ `competency_profile_extended_${index}` }
            className={ `${style.competencyRow} ${classes.competencyRow}` }
            onClick={ event => {
                event.stopPropagation();
                openCompetencyExtendedModal('modal_competency_profile_extended', modalContent);
            }}
        >
            <header className={ `${style.competencyHeader} ${classes.competencyHeader}` }>
                <CompetencyIcon
                    handle={ `icon_${competency.translationKeyName}` }
                    developabilityLabel={competency.developabilityLabel}
                    developabilityScore={competency.developabilityScore}
                />
                <h4>{ ReportHelper.getCompetencyName(competency, languageId, i18n) }</h4>
                <span className={ style.arrowRight }>&gt;</span>
            </header>

            <CompetencyScoreBar competency={ competency } i18n={ i18n } />
        </li>;
    }

    render() {
        const {
            competencies,
            openCompetencyExtendedModal,
            closeCompetencyExtendedModal,
            classes,
            i18n,
            languageId
        } = this.props;

        const competenciesWithTags = this.getCompetenciesWithTags(competencies, languageId, i18n);

        const output = competenciesWithTags.map(competencyGroup => {
            return <>
                {
                    competenciesWithTags.length > 1 && <div className={style.competencyTagHeader}><span>{competencyGroup.tag}</span></div>
                }
                {
                    competencyGroup.competencies.map((competency, index) => {

                        return this.getRenderedCompetency(
                            competencies,
                            openCompetencyExtendedModal,
                            closeCompetencyExtendedModal,
                            classes,
                            i18n,
                            languageId,
                            competency,
                            index
                        );

                    })
                }
            </>;
        });

        return (
            <ul className={ `${style.competencyProfileExtended} ${classes.competencyProfileExtended}` }>
                { output }
            </ul>
        );
    }
}

export default CompetencyProfileExtended;

CompetencyProfileExtended.propTypes = {
    competencies: PropTypes.array,
    openCompetencyExtendedModal: PropTypes.func,
    closeCompetencyExtendedModal: PropTypes.func,
    classes: PropTypes.object
};

CompetencyProfileExtended.defaultProps = {
    competencies: [],
    classes: {
        competencyRow: '',
        competencyHeader: '',
        competencyProfileExtended: ''
    }
};
